import { Box, Divider, TabContext, TabList, Tab, classes } from 'bonfire-kindling';

import SavedSearchSettingsUpsertTab from './SavedSearchSettingsUpsertTab';
import SavedSearchSettingsUpsertTabPanel from './SavedSearchSettingsUpsertTabPanel';

const SavedSearchSettingsUpsertTabs = ({ fields, currentTab, onTabChange }) => (
  <>
    <Divider sx={{ my: 4 }} />
    <Box sx={{ display: 'flex', flexGrow: 1 }}>
      <TabContext value={currentTab}>
        <TabList
          variant="fullWidth"
          orientation="vertical"
          onChange={(_, value) => onTabChange(value)}
          sx={{
            [`& .${classes.components.MuiTabs.indicator}`]: {
              display: 'none',
            },
          }}
        >
          {fields.map(({ title, description, id }) => (
            <Tab
              key={id}
              value={id}
              title={title}
              description={description}
              component={SavedSearchSettingsUpsertTab}
            />
          ))}
        </TabList>
        {fields.map(({ id, component }) => (
          <SavedSearchSettingsUpsertTabPanel key={id} value={id} sx={{ flex: '1 1 0%' }}>
            {component}
          </SavedSearchSettingsUpsertTabPanel>
        ))}
      </TabContext>
    </Box>
    <Divider sx={{ my: 4 }} />
  </>
);

export default SavedSearchSettingsUpsertTabs;
